<template>
  <f7-page name="recommendfriendHistory" class="modern-ui">
    <bc-navbar></bc-navbar>
    <div class="page-container">
      <f7-link :href="backLink" class="mui-button accent-50"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M7.625 12.5L3.125 8L7.625 3.5M3.75 8H12.875" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg> Back</f7-link>

      <h1 class="title">
        Referral History
      </h1>

      <referrals-filter class="filter" :value="historyFilter" @change="onFilterChange($event)" :options="statuses" />

      <search @search="onSearch($event)"/>

      <div class="history-list" ref="historyList" v-if="history.length">
        <referral-history-item v-for="item in history" :key="item.referralHistoryId" :data="item"
          @onShareFb="shareToFb(item)" @edit="edit(item)" @send="send(item)" @resend="resend(item)" @sendSalespersonSms="sendSalespersonSms()" />
      </div>
      <span class="no-content" v-if="!history.length && historyLoaded">{{ search ? 'referrals not found': 'no referrals yet' }}</span>
      <div class="buttons fx fx-col">
        <button class="mui-button accent" @click="onAddReferral()">Refer more friends</button>
      </div>
    </div>

    <loader :show="showLoader" />

  </f7-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ReferralsFilter from '../../components/referral/referrals-filter.vue'
import ReferralsHistoryItem from '../../components/referral/referral-history-item.vue'
import Loader from '@components/loader.vue'
import { PAGES } from '../../shared/routes.constants'
import { ReferralProgramHistoryStatus } from '@/shared/enums/referral.enum.js'
import { notify } from '@/shared/notifications.js'
import { openSMSEditor } from '@/helpers/sms-editor.js'
import Search from '../../components/search.vue'
/* eslint-disable */

export default {
  name: "recomend-friend",
  components: {
    loader: Loader,
    "referrals-filter": ReferralsFilter,
    "referral-history-item": ReferralsHistoryItem,
    'search': Search
  },
  mounted: async function () {
    this.loading = true;
    try {
      await this.loadHistory();
      await this.getStatuses();
      await this.getReferralProgramInfo();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapState({
      salesPersonPhone: (state) => state.common.phone,
    }),
    ...mapGetters({
      history: "recommendFriend/history",
      statuses: "recommendFriend/statuses",
      historyLoaded: "recommendFriend/historyLoaded",
      sharedLinkData: "recommendFriend/sharedLinkData",
    }),
    showLoader() {
      return !this.historyLoaded || this.loading
    }
  },
  methods: {
    ...mapActions({
      getHistory: "recommendFriend/loadRecommendFriendHistory",
      getStatuses: "recommendFriend/loadHistoryStatuses",
      editReferral: "recommendFriend/editReferral",
      deleteReferral: "recommendFriend/deleteReferral",
      getReferralProgramInfo: "recommendFriend/getInfo",
      addReferral: "recommendFriend/addReferral",
      getReferralMessage: "recommendFriend/getReferralMessage",
      getSharedLink: "recommendFriend/getShareLink",
      sendSharedLink: "recommendFriend/sendSharedLink",
    }),
    async onFilterChange(value) {
      this.historyFilter = value;
      await this.loadHistory();
    },
    async onSearch(val){
      this.search = val;
      this.resetScroll();
      await this.getHistory({status: this.historyFilter, search: this.search});
    },
    async loadHistory() {
      this.resetScroll();
      await this.getHistory({status: this.historyFilter});
    },
    onAddReferral() {
      this.$router.load({ url: `/${PAGES.RecommendAFriendReferral}` })
    },
    edit(referral) {
      this.$router.load({ url: `/${PAGES.RecommendAFriendReferral}/${referral.referralHistoryId}` })
    },
    async shareToFb() {
      const { link, title } = this.sharedLinkData;
      try {
        navigator
          .share({
            url: link,
            title: title,
          })
          .then(() => this.onShareResult());
      } catch (err) {
        notify.error("Error during share proccess");
      }
    },
    onShareResult() {
      this.sendSharedLink().then(() => {
        notify.success("Link shared successfully!");
      });
    },
    async send(referral) {
      await this._sendReferral(referral.referralContactPhone, referral.code);
    },
    async resend(referral) {
      await this._sendReferral(referral.referralContactPhone, referral.code);
    },
    sendSalespersonSms(){
      openSMSEditor(this.salesPersonPhone)
    },
    async _sendReferral(phone, code) {
      this.loading = true
      const res = await this.getReferralMessage(code)
      if (!res.success) {
        notify.error('Error during get message text')
        this.loading = false
        return
      }
      const text = res.model
      openSMSEditor(phone, text)
      notify.success("Message was sent successfully!");
      await this.loadHistory();
      this.loading = false
    },
    resetScroll() {
      if (!this.$refs.historyList) {
        return
      }
      this.$nextTick(() => {
        this.$refs.historyList.scrollTop = 0;
      });
    },
  },
  data() {
    return {
      title: "Referral History",
      backLink: PAGES.RecommendAFriend,
      historyFilter: ReferralProgramHistoryStatus.None,
      ReferralProgramHistoryStatus: ReferralProgramHistoryStatus,
      loading: false,
      search: null
    };
  },
};
</script>
<style scoped lang="scss">
.page-container {
  padding-inline: 18px;
  padding-block: 8px 16px;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  >.title{
    font-weight: 600;
    font-size: 28px;
  }
}

.history-list {
  display: grid;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  margin-bottom: 15px;
  align-content: flex-start;
}

.buttons {
  margin-top: auto;
  gap: 10px;
}

.no-content {
  color: #8f8e8e;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// recommend-friend-history.vue?ff8e265a